/**
 * Enumeration of all pages
 */
export enum Page {
    /** Represents the CanvasComponent */
    Canvas = "canvas",
    Dance = "dance",
    Wordle = "wordle",
    Keypad = "keypad",
    GameBinos = "game-binos",
};
